import roles from './roles'

/**
 * Rational application settings
 */
export default {
  languages: ['en', 'de', 'fr', 'es', 'pt', 'tr', 'it', 'pl', 'ru', 'zh', 'ja', 'cs', 'sv', 'hu', 'he', 'hr', 'el', 'nl'],
  singleStepLogin: false,
  oauth: { enabled: true, auto: false },
  namespaces: [
    'cart',
    'equipmentInformation',
    'favorite',
    'feedback',
    'optionManagement',
  ],
  maximumPersistenceDays: 5,
  maximumPersistedRequestBytes: 1_048_576,
  maximumPersistedFileBytes: 524_288,
  simpleNavigationIcons: true,
  allowNonEmailUsernames: true,
  showOnboardingWarningConfirmation: true,
  suppressUserExistenceCheck: true,
  suppressProfileRole: true,
  lowercaseStatuses: true,
  suppressExternalTeams: true,
  // externalPortalUrl: 'https://portal.rational-online.com/fs4p/{lang}/startseite/homepage_eingeloggt.php',
  externalPortalUrl: 'https://my.rational-id.com',
  externalProfileUrl: 'https://my.rational-id.com/self-service/password',
  suppressUnderlineInHyperlinks: true,
  staticActions: [
    {
      aclContextRole: ['!PinCreatorOnly_c'],
      options: {
        name: 'digitalServiceManager',
        icon: 'digital-service-management',
        url: 'https://service.connectedcooking.com',
      },
    },
    {
      aclContextRole: ['!PinCreatorOnly_c'],
      options: {
        name: 'marine',
        icon: 'anchor',
      },
    },
    {
      options: {
        name: 'imprint',
        icon: 'imprint',
      },
    },
    {
      options: {
        name: 'cra',
        icon: 'shield-tick',
      },
    },
  ],
  // This is an object because there will be more props in the near future
  webShop: {
    enabled: true,
  },
  drilldown: {
    minStepsDepth: 1,
    skippableDepths: [
      { depth: 7, nodeType: 'product', productType: 'SCC' },
      { depth: 7, nodeType: 'product', productType: 'iCombi' },
      { depth: 6, nodeType: 'product', productType: 'VCC' },
      { depth: 6, nodeType: 'product', productType: 'iVario' },
    ],
  },
  documentationTreeFilter: {
    product: [
      { number: 'RTS-GMNA1', nodeType: 'product', name: 'SCC' },
      { number: 'RTS-GMNB1', nodeType: 'product', name: 'SCC' },
      { number: 'RTS-GMNC1', nodeType: 'product', name: 'iCombi' },
      { number: 'RTS-GMNC_LM5', nodeType: 'product', name: 'LM5' },
      { number: 'RTS-GMNC145', nodeType: 'product', name: 'iCombi' },
      { number: 'SAV-TDAA1', nodeType: 'product', name: 'VCC' },
      { number: 'SAV-TDB1', nodeType: 'product', name: 'iVario' },
    ],
    // If we are viewing an LM5 equipment, treat it as iCombi for the `isProduct` check
    productAliases: {
      iCombi: 'LM5',
      //iVario: 'LMX3'
    },
    docType: [
      { errorTree: { nodeType: 'documentation', name: 'ET' } },
      { bulletin: { nodeType: 'documentation', name: 'BU' } },
      { serviceReference: { nodeType: 'documentation', name: 'SR' } },
    ],
    filter: [
      { energy: { /* more detailed filter may come here */ } },
      { size: { /* more detailed filter may come here */ } },
      { type: { /* more detailed filter may come here */ } },
    ],
  },
  documentationTreeNodeIcons: [
    { nodeType: 'product', name: 'SCC', icon: { name: 'product-scc' } },
    { nodeType: 'product', name: 'VCC', icon: { name: 'product-vcc' } },
    { nodeType: 'product', name: 'iVario', icon: { name: 'product-ivario' } },
    { nodeType: 'product', name: 'iCombi', icon: { name: 'product-icombi' } },
    { nodeType: 'product', name: 'iHexagon', icon: { name: 'product-icombi' } },
    { nodeType: 'product', name: 'LM5', icon: { name: 'product-lm5' } },

    { nodeType: 'documentation', name: 'BU', icon: { name: 'documentation-bu' } },
    { nodeType: 'documentation', name: 'CL', icon: { name: 'documentation-cl' } },
    { nodeType: 'documentation', name: 'ET', icon: { name: 'documentation-et' } },
    { nodeType: 'documentation', name: 'FAQ', icon: { name: 'documentation-faq' } },
    { nodeType: 'documentation', name: 'IM', icon: { name: 'documentation-im' } },
    { nodeType: 'documentation', name: 'MI', icon: { name: 'documentation-mi' } },
    { nodeType: 'documentation', name: 'OM', icon: { name: 'documentation-om' } },
    { nodeType: 'documentation', name: 'SI', icon: { name: 'documentation-si' } },
    { nodeType: 'documentation', name: 'SN', icon: { name: 'documentation-sn' } },
    { nodeType: 'documentation', name: 'SR', icon: { name: 'documentation-sr' } },
    { nodeType: 'documentation', name: 'TI', icon: { name: 'documentation-ti' } },
    { nodeType: 'documentation', name: 'TM', icon: { name: 'documentation-tm' } },
    { nodeType: 'documentation', name: 'TV', icon: { name: 'documentation-tv' } },
    { nodeType: 'documentation', name: 'TR', icon: { name: 'documentation-tr' } },
  ],
  documentationTreeBoldLabels: true,
  plugins: ['optionManagement', 'userlane'],
  pinCreator: {
    enabled: true,
    pvKeySeparator: '###',
    pvKeyUrl: '/api/v1/pincreator/key',
    keyRegex: /^.*"KEY":\s*(\{.*"}),.*$/,
    magicRegex: /^.*"Magic":\s*([0-9]+),.*$/,
  },
  roles,
}
